import React from 'react'
import FadeInOut from "../../../component/Global/FadeInOut";
import newarklogo from "src/assets/images/newark-logo.svg";
import newarkiconone from "src/assets/images/newark-store-icon1.png";
import newarkicontwo from "src/assets/images/newark-store-icon2.png";
import newarkiconthree from "src/assets/images/newark-store-icon3.png";

export const ProductDetailEsop = () => {
  return (
    <>
      <FadeInOut show={true} duration={500} className={'visit-newark-box'}>
        <div className='d-flex justify-content-between'>
          <span className='new-tag'>
            <p>New</p>
          </span>
          <span className='pdp-newark-logo'>
            <img src={newarklogo} className="" />
          </span>

        </div>
        <div className='pdp-newark-content text-center'>
          <h1 className='font-oswald font-28 text-darkgreen text-center'>Visit the Newark Store</h1>
          <p className='font-arial font-13 mt-2 mb-3 text-center'>Newark, an Avnet company, is a fast and reliable distributor which brings to you:</p>
          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkiconone} className="" />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>PROTOTYPE QUANTITIES</b></h5>
              <p className='font-arial font-13 text-left mb-0'>950,000+ products in stock</p>
            </div>
          </div>

          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkicontwo} className="" />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>Wide range of Products</b></h5>
              <p className='font-arial font-13 text-left mb-0'>from 2,000+ leading suppliers</p>
            </div>
          </div>

          <div className='d-flex pdp-newark-content-list '>
            <span>
              <img src={newarkiconthree} className="" />
            </span>
            <div>
              <h5 className='font-arial font-13 mb-0 text-left mt-0'><b>FAST AND RELIABLE</b></h5>
              <p className='font-arial font-13 text-left mb-0'>delivery with same-day dispatch,<br /> 24h-48h delivery</p>
            </div>
          </div>
          
          <a target={"_blank"} href="https://www.newark.com/?CMP=AMER-AVNET-ESPOT" className='bs5 btn btn-secondary m-auto'>click here to visit newark</a>
        </div>
      </FadeInOut>
    </>
  )
}
